import { createKeyedDataAsyncSlice } from '../createKeyedDataAsyncSlice';
import { updateClientLoanAmountAsync } from '../../API/clientPortal/clientOrderAPI';

export const { slice: updateClientLoanAmountSlice, asyncAction: updateClientLoanUpdateAccountAction } =
  createKeyedDataAsyncSlice(
    'updateClientLoanAmount',
    updateClientLoanAmountAsync,
    ({ orderId }) => `${orderId}`
  );
